import React from 'react';

import { COLOR_L5_PRIMARY_500 } from '../consts';

type Props = {
    fill?: string;
    width?: number;
    height?: number;
};
const CheckboxUncheckedIcon = React.memo(function CheckboxUncheckedIcon({
    fill = COLOR_L5_PRIMARY_500,
    width = 20,
    height = 20,
}: Props) {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect x="0.75" y="0.75" width="18.5" height="18.5" rx="1.25" fill="white" />
            <rect
                x="0.75"
                y="0.75"
                width="18.5"
                height="18.5"
                rx="1.25"
                stroke={fill}
                strokeWidth="1.5"
            />
            <rect x="4.5" y="9" width="11" height="1.5" fill={fill} />
        </svg>
    );
});

export default CheckboxUncheckedIcon;
